export default {"src":"/_next/static/media/nomad_on-light.8cc413a7.svg","height":72,"width":202,"blurWidth":0,"blurHeight":0};